import { getText } from '@amzn/awscat-editor';
import { ContentMetadata } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { withAppContext } from '../../contexts/AppContext';
import { Link } from '@amzn/awsui-components-core';

const PostViewerLink: React.FC<{ contentId: string; metadata: ContentMetadata }> = ({
  contentId,
  metadata,
}) => {
  return (
    <Link variant="secondary" href={`/post-viewer/${contentId}`} target="_blank">
      {getText(metadata.contentName)}
    </Link>
  );
};

export default withAppContext(PostViewerLink);
